export default __webpack_public_path__ + "static/media/email_icon.2cd59c63.svg";